export default __webpack_public_path__ + "static/media/SpaceGrotesk-Light.1307383a.woff";